/** @format */
import React from "react";
import { Button, Dropdown } from "antd";
import styles from "../styles/ui/ActionButton.module.css";
import { Link } from "react-router-dom";

function ActionButton({
  icon,
  label,
  value,
  onClick,
  dropdownOptions,
  disabled = false,
  loading = false,
  asLink = false,
  linkTo = "#",
  isToggle = false,
  toggleValue = false,
  toggleOptions = {}, // { activeIcon, inactiveIcon }
  useAntdButton = false,
  children,
  filled = false,
  showLabelSeparator = true,
  className = "",
}) {
  const baseStyle = {
    opacity: disabled ? 0.6 : 1,
    cursor: disabled ? "not-allowed" : "pointer",
  };

  // btn with loading
  if (useAntdButton) {
    return (
      <li className={`${styles.button} ${className}`} onClick={onClick}>
        <Button
          loading={loading}
          disabled={disabled}
          onClick={(e) => e.preventDefault()}
        >
          {icon && !loading && <span className={styles.icon}>{icon}</span>}
          {label}
        </Button>
      </li>
    );
  }

  // toggle btn
  if (isToggle) {
    return <li className={`${styles.button} ${className}`}>{children}</li>;
  }

  // link btn
  if (asLink) {
    const isExternal = linkTo?.startsWith("http") || linkTo?.endsWith(".pdf");

    return (
      <>
        {isExternal ? (
          <li>
            <a
              href={linkTo}
              download
              target="_blank"
              rel="noopener noreferrer"
              className={`${styles.button}`}
              style={{ lineHeight: "unset" }}
            >
              {icon && <span className={styles.icon}>{icon}</span>}
              {label && <span>{label}</span>}
            </a>
          </li>
        ) : (
          <li className={`${styles.button} ${styles.displayOnly} ${className}`}>
            <Link to={linkTo}>
              {icon && <span className={styles.icon}>{icon}</span>}
              {label && <span>{label}:</span>}
              {value && <span className={styles.value}>{value}</span>}
            </Link>
          </li>
        )}
      </>
    );
  }

  // dropdown btn
  if (dropdownOptions) {
    return (
      <Dropdown
        menu={{
          items: dropdownOptions.items,
          onClick: dropdownOptions.onClick,
          selectedKeys: dropdownOptions.selectedKeys,
        }}
        trigger={["click"]}
        disabled={disabled}
      >
        <li className={`${styles.button} ${className}`} style={baseStyle}>
          {icon && <span className={styles.icon}>{icon}</span>}
          {label && (
            <span>
              {label}
              {showLabelSeparator ? ":" : ""}
            </span>
          )}
          {value && <span className={styles.value}>{value}</span>}
        </li>
      </Dropdown>
    );
  }

  // custom btn
  if (children)
    return (
      <li className={`${styles.button} ${className}`} onClick={onClick}>
        <Button
          loading={loading}
          disabled={disabled}
          onClick={(e) => e.preventDefault()}
        >
          {icon && !loading && <span className={styles.icon}>{icon}</span>}
          {children}
        </Button>
      </li>
    );

  // normal btn
  return (
    <li
      className={`${styles.button} ${filled ? styles.filled : ""} ${className}`}
      onClick={onClick}
      style={baseStyle}
    >
      {icon && <span className={styles.icon}>{icon}</span>}
      {label && <span>{label}</span>}
      {value && <span className={styles.value}>{value}</span>}
    </li>
  );
}

export default ActionButton;
